import React from 'react';
import DefaultSelect from '../Default/DefaultSelect';

export default function PartsStatusSelect({onChange, required}) {
    const options = [
        {value: "Ordered", label: "Ordered"},
        {value: "Warehouse IM", label: "Warehouse IM"},
        {value: "Picked", label: "Picked"},
        {value: "Warehouse JCE", label: "Warehouse JCE"},       
        {value: "Installed", label: "Installed"},
        {value: "Shipped", label: "Shipped"},
        {value: "Blocked", label: "Blocked"},
        {value: "Discontinued", label: "Discontinued"},
    ];

    return (
        <>
            <DefaultSelect required={required} options={options} onChange={(e) => onChange(e)}
                           label="Parts status"/>
        </>
    )
}